import React from 'react'
import {
  FilterBetweenDates,
  FilterBetweenDatesInner
} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const StartDateFilterBadge = (props) => {
  const { translate } = useTranslation()
  const { startDateFilter, setStartDateFilter, typeFilter, useInner = false } = props
  const hasDateFilter = startDateFilter?.some(Boolean)

  const checkboxSelectorProps = {
    className: 'h45',
    strings: {
      // title: translate('filters.plans.startDateTitle'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      from: translate('filters.plans.fromDate'),
      to: translate('filters.plans.toDate')
    },
    setDates: setStartDateFilter,
    typeFilter: typeFilter,
    dates: startDateFilter,
    direction: 'bottomCenter'
  }

  if (useInner) {
    return <FilterBetweenDatesInner style={{ maxWidth: 'auto' }} {...checkboxSelectorProps} />
  }

  return (
    <FilterBetweenDates {...checkboxSelectorProps}>
      <FilterBadge
        title='Dates'
        isActive={hasDateFilter}
        onClearFilters={() => setStartDateFilter([])}
      />
    </FilterBetweenDates>
  )
}
export default StartDateFilterBadge
